import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.scss']
})
export class CompanyDetailsComponent implements OnInit, OnDestroy {

  private typeAheadSubject = new Subject<{event:Event, type:String}>();

  viewMore = false;
  viewMore2 = false;
  hasViewMore2: boolean = null;
  companyId: any;
  companyDetails: any;
  linkedin_url: any;
  twitter_url: any;
  facebook_url: any;
  tags: string[] = [];
  @ViewChild('tta') tta: ElementRef<HTMLDivElement>;
  alternatecompanyNames: any
  locationList: any = []
  showLocationLoader: boolean = false
  filterSelectedLocation: any[] = []
  location_input: FormControl = new FormControl(null)
  skillsList: any = []
  skill_input: FormControl = new FormControl(null)
  showSkillLoader: boolean = false
  filterSelectedSkills: any[] = []
  functionsList: any = []
  showfunctionLoader: boolean = false
  function_input: FormControl = new FormControl(null)
  filterSelectedFunctions: any [] = []
  companyname: any;
  insightsExportSubscription: Subscription = null;
  successMessage: string = '';
  errorMessage: string = '';
  allowExport: boolean = false;
  /**
   * Normalized tab-names for insights-export API payload
   */
  normalizedTabNamesForInsightsExport: any = { 'overview': 'overview', 'location': 'location', 'attrition': 'attritionandhiring', 'education': 'education', 'skills': 'skills', 'titles': 'titles', 'talent-movement': 'talentmovement', 'profile': 'profile', 'diversity': 'diversity' };

  continentList:any[] = [{key: 'asia', doc_count: 0}, {key: 'africa', doc_cout: 0}, {key: 'south america', doc_count: 0}, {key: 'north america', doc_count: 0}, {key: 'oceania', doc_count: 0}];
  continentSelectedList: any[] = [];

  subscriptions: Array<Subscription> = [];
  
  constructor(
    private router: Router, 
    private activatedRoute: ActivatedRoute, 
    private companyInsightsService: CompanyInsightsService, 
    private personSearchService: PersonSearchService,
    private localstorageservice: LocalStorageService,
    private filterDataHandlerService: FilterDataHandlerService
  ) { }

  ngOnInit(): void {
    this.companyId = this.activatedRoute.snapshot.params['company-id'];
    // this.companyInsightsService.getCompanyDetailsById(this.companyId).subscribe((res:any)=>{
    //   this.companyInsightsService.setCompanyListData(res.data);
    //   this.companyInsightsService.setCompanyData(res.data);
    //   this.companyDetails = res.data;
    //   this.companyname = this.companyDetails.name
    //   this.alternatecompanyNames = this.companyDetails.alternative_names && this.companyDetails.alternative_names.length > 0 ? this.companyDetails.alternative_names.concat([this.companyDetails.name]): [this.companyDetails.name]

      // this.personSearchService.companyDetailNext(res.data);
      // this.localstorageservice.setItem('companyinsightsdetails', JSON.stringify(res.data)); TODO : Handle local storage handling
      // this.linkedin_url = this.companyDetails.linkedin_url;
      // this.twitter_url = this.companyDetails.twitter_url;
      // this.facebook_url = this.companyDetails.facebook_url;

    //     this.populateTags();
      

    //   this.typeAheadSubject.pipe(debounceTime(500)).subscribe(({event, type})=>{
    //     this.typeaheadSearch(event,type);
    //   })

    // });
    const companyDetailsSub = this.companyInsightsService.getCompanyDetailsById(this.companyId).subscribe((res:any) => this.processCompanyDetailsResponse(res));
    this.subscriptions.push(companyDetailsSub);
    this.filterDataHandlerService.reset();
    this.localstorageservice.setItem(GeneralConstants.LS_KEYS.COMPANY_FILTERS, this.filterDataHandlerService.fetchFilterData)
    // const filterData = JSON.parse(this.localstorageservice.getItem(GeneralConstants.LS_KEYS.COMPANY_FILTERS)); 
    // console.log("companyfilyer", filterData);
    // if (!filterData || _.isEmpty(filterData)) {
    //   this.filterDataHandlerService.reset();
    // } else {
    //   this.filterDataHandlerService.setFilterData(filterData);
    // }
  }


  private processCompanyDetailsResponse(response: any) {
    this.companyInsightsService.setCompanyListData(response?.data);
    this.companyInsightsService.setCompanyData(response?.data);
    this.companyDetails = response?.data;
    this.companyname = this.companyDetails?.name;
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this.companyDetails?.name]): [this.companyDetails?.name]
    // TODO : Remove below commented code later.
    // For now we are not calling this will monitor and fix if something is breaking. 
    // The idea is to use the shared company details object that is being set in this methods second line
    // this.personSearchService.companyDetailNext(response.data);
    this.linkedin_url = this.companyDetails.linkedin_url;
    this.twitter_url = this.companyDetails.twitter_url;
    this.facebook_url = this.companyDetails.facebook_url;

    this.populateTags();
  }

  ngOnDestroy(): void {
    this.companyInsightsService.setCompanyData(null);

    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  get ttaview() {
    if (this.hasViewMore2 === null && this.tta && this.tta.nativeElement && this.tta.nativeElement.scrollHeight && this.tta.nativeElement.clientHeight >= 25) {
      this.hasViewMore2 = this.tta.nativeElement.scrollHeight > this.tta.nativeElement.clientHeight;
    }
    return this.hasViewMore2;
  }

  /**
   * Utility function to convert string to titlecase format
   * @param inputString 
   */
  convertToTitleCase(inputString: string) {
    const inputStringToWords = inputString.toLowerCase().split(' ');
    for(let i = 0; i < inputStringToWords.length; i++) {
      inputStringToWords[i] = inputStringToWords[i].charAt(0).toUpperCase() + inputStringToWords[i].slice(1);
    }
    return inputStringToWords.join(' ');
  }

  /**
   * Populate tags
   */
  populateTags() {
    if (this.companyDetails && this.companyDetails.tags) {
      this.tags = this.companyDetails.tags.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
    }
  }

  openUrl(link, type) {
    if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
      link = "https://" + link;
    else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
      link = "https://www." + link;
    else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
      link = "https://www." + link;
    else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
      link = "https://www." + link;
    else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
      link = "https://www." + link;
    window.open(link, "_blank")
  }

  typeaheadSearch(event, type) {
    const input = event.target.value
    const requestObject = {
      "startindex": 0,
      "resultsize": 5,
      "searchviaboolean": true,
      "booleanquery": "*",
      "jobtitles": [],
      "preferredskills": this.filterSelectedSkills && this.filterSelectedSkills.length ? this.filterSelectedSkills: [],
      "mandatoryskills": [],
      "locations": this.companyDetails && this.companyDetails['locations'] ? this.companyDetails['locations']: [],
      "companies": this.alternatecompanyNames,
      "industries": [],
      "exclusionlist": [],
      "genders": [
        "All"
      ],
      "seniority": [
        "All"
      ],
      "graduationyear": [],
      "schools": [],
      "schooltypes": [],
      "educationaldegrees": [],
      "educationalmajors": [],
      "candidateshavingemails": false,
      "candidateshavingcontactnumbers": false,
      "minexperience": null,
      "maxexperience": null,
      "minexperienceinccurrentcompany": null,
      "zipcodes": [],
      "companysizes": [
        "All"
      ],
      "candidateshavingcontacts": false,
      "workregions": [],
      "workcountries": [],
      "worklocalities": [],
      "spokenlanguages": [],
      "contacts": [
        "All"
      ],
      "candidateshavingmobilenumber": false,
      "candidateshavingpersonalemail": false,
      "candidateshavingprofessionalemail": false,
      "candidateshavingsocialprofiles": false,
      "fromgraduationyears": [],
      "tograduationyears": [],
      "exclude_jobtitles": [],
      "exclude_companies": [],
      "exclude_locations": [],
      "companytype": "Current",
      "jobtitletype": "All",
      "industrytype": "All",
      "fromyearsofexperience": [],
      "toyearsofexperience": [],
      "experiencetype": "Total",
      "likelytomovetype": null,
      "salaries": [
        "All"
      ],
      "salaryranges": [
        "All"
      ],
      "functions": this.filterSelectedFunctions && this.filterSelectedFunctions.length ? this.filterSelectedFunctions: [],
      continentstobeincluded: this.continentSelectedList && this.continentSelectedList.length ? this.continentSelectedList: []

    };
    if(type == 'location') {
      requestObject['typeahead'] = 'typeahead_location'
      requestObject['input'] = input
      this.showLocationLoader = true
      this.companyInsightsService.getTotalCompanyaggs(requestObject).subscribe((response: any) => {
        if (response.status == 'success' && response.data) {
          this.locationList = response.data.aggs;
          this.locationList.push(this.continentList);
          this.locationList = _.flatten(this.locationList);
          this.locationList = this.locationList.filter((x) =>{ return x.key.toLowerCase().includes(input.toLowerCase()) });
          this.showLocationLoader = false
        }
      });
    } else if(type == 'skill') {
      requestObject['typeahead'] = 'typeahead_skills'
      requestObject['input'] = input
      this.showSkillLoader = true
      this.companyInsightsService.getTotalCompanyaggs(requestObject).subscribe((response: any) => {
        if (response.status == 'success' && response.data) {
          this.skillsList = response.data.aggs;
          this.showSkillLoader = false
        }
      });
    } else if(type == 'function') {
      requestObject['typeahead'] = 'typeahead_function'
      requestObject['input'] = input
      this.showfunctionLoader = true
      this.companyInsightsService.getTotalCompanyaggs(requestObject).subscribe((response: any) => {
        if (response.status == 'success' && response.data) {
          this.functionsList = response.data.aggs;
          this.showfunctionLoader = false
        }
      });
    }
  }

  onTypeAheadSearch(event, type){
    this.typeAheadSubject.next({event, type});
  }

  selectOption(event, type) {
    if(type == 'location') {
      const iscontinent = this.continentList.find(x=>x.key== event.key);
      if(iscontinent) {
        this.continentSelectedList.push(iscontinent.key);
        this.companyDetails['continents'] = this.continentSelectedList;
      }
        this.filterSelectedLocation.push(event.key);
        this.companyDetails['locations'] = this.filterSelectedLocation.filter(x=>(x!='asia' && x!= 'africa' && x!= 'north america' && x!= 'south america' && x!= 'oceania'));
        this.location_input.patchValue(null);
    } else if(type == 'skill') {
      this.filterSelectedSkills.push(event.key)
      this.skill_input.patchValue(null)
      this.companyDetails['skills'] = this.filterSelectedSkills;
    } else if(type == 'function') {
      this.filterSelectedFunctions.push(event.key)
      this.function_input.patchValue(null)
      this.companyDetails['functions'] = this.filterSelectedFunctions;
    }
    this.personSearchService.companyDetailNext(this.companyDetails);
    this.localstorageservice.setItem('companyinsightsdetails', JSON.stringify(this.companyDetails));

    // const tab = this.router.url.split('/')[3]
    // this.router.navigate([`/company-details/${this.companyDetails.id}/${tab}`], {state: this.companyDetails, relativeTo: this.activatedRoute, skipLocationChange: true})
  }

  unselect(value, type) {
    if(type == 'location') {
      this.filterSelectedLocation = _.without(this.filterSelectedLocation, value)
      this.location_input.patchValue(null);
      const iscontinent = this.continentList.find(x=>x.key== value);
      if(iscontinent) {
        this.continentSelectedList = _.without(this.continentSelectedList, value);
        this.companyDetails['continents'] = this.continentSelectedList;
      }
      this.companyDetails['locations'] = this.filterSelectedLocation;
    
    } else if(type == 'skill') {
      this.filterSelectedSkills = _.without(this.filterSelectedSkills, value)
      this.skill_input.patchValue(null)
      this.companyDetails['skills'] = this.filterSelectedSkills;
    
    } else if(type == 'function') {
      this.filterSelectedFunctions = _.without(this.filterSelectedFunctions, value)
      this.function_input.patchValue(null)
      this.companyDetails['functions'] = this.filterSelectedFunctions;
    
    } 

    this.personSearchService.companyDetailNext(this.companyDetails);
    this.localstorageservice.setItem('companyinsightsdetails', JSON.stringify(this.companyDetails));
    const tab = this.router.url.split('/')[3]
    this.router.navigate([`/company-details/${this.companyDetails.id}/${tab}`], {state: this.companyDetails, relativeTo: this.activatedRoute, skipLocationChange: true})
  }

  clearAll() {
    this.location_input.patchValue(null);
    this.skill_input.patchValue(null);
    this.function_input.patchValue(null);
    this.filterSelectedLocation = [];
    this.filterSelectedSkills = [];
    this.filterSelectedFunctions = [];
    this.companyDetails['locations'] = []
    this.companyDetails['skills'] = []
    this.companyDetails['functions'] = [];
    this.continentSelectedList = [];
    this.companyDetails['continents'] = [];
    this.personSearchService.companyDetailNext(this.companyDetails);
    this.localstorageservice.setItem('companyinsightsdetails', JSON.stringify(this.companyDetails));
    const tab = this.router.url.split('/')[3]
    this.router.navigate([`/company-details/${this.companyDetails.id}/${tab}`], {state: this.companyDetails, relativeTo: this.activatedRoute, skipLocationChange: true})
  }

  getTypeaheads(type) {
    const requestObject = {
      "startindex": 0,
      "resultsize": 5,
      "searchviaboolean": true,
      "booleanquery": "*",
      "jobtitles": [],
      "preferredskills": this.filterSelectedSkills && this.filterSelectedSkills.length ? this.filterSelectedSkills: [],
      "mandatoryskills": [],
      "locations": this.companyDetails && this.companyDetails['locations'] ? this.companyDetails['locations']: [],
      "companies": this.alternatecompanyNames,
      "industries": [],
      "exclusionlist": [],
      "genders": [
        "All"
      ],
      "seniority": [
        "All"
      ],
      "graduationyear": [],
      "schools": [],
      "schooltypes": [],
      "educationaldegrees": [],
      "educationalmajors": [],
      "candidateshavingemails": false,
      "candidateshavingcontactnumbers": false,
      "minexperience": null,
      "maxexperience": null,
      "minexperienceinccurrentcompany": null,
      "zipcodes": [],
      "companysizes": [
        "All"
      ],
      "candidateshavingcontacts": false,
      "workregions": [],
      "workcountries": [],
      "worklocalities": [],
      "spokenlanguages": [],
      "contacts": [
        "All"
      ],
      "input": '',
      "candidateshavingmobilenumber": false,
      "candidateshavingpersonalemail": false,
      "candidateshavingprofessionalemail": false,
      "candidateshavingsocialprofiles": false,
      "fromgraduationyears": [],
      "tograduationyears": [],
      "exclude_jobtitles": [],
      "exclude_companies": [],
      "exclude_locations": [],
      "companytype": "Current",
      "jobtitletype": "All",
      "industrytype": "All",
      "fromyearsofexperience": [],
      "toyearsofexperience": [],
      "experiencetype": "Total",
      "likelytomovetype": null,
      "salaries": [
        "All"
      ],
      "salaryranges": [
        "All"
      ],
      "functions": this.filterSelectedFunctions && this.filterSelectedFunctions.length ? this.filterSelectedFunctions: [],
      continentstobeincluded: this.continentSelectedList && this.continentSelectedList.length ? this.continentSelectedList: []

    };

    if(type == 'location') {
      requestObject['typeahead'] = 'typeahead_location'
      this.showLocationLoader = true
      this.companyInsightsService.getTotalCompanyaggs(requestObject).subscribe((response: any) => {
        if (response.status == 'success' && response.data) {
          this.locationList = response.data.aggs;
          this.locationList.push()
          this.showLocationLoader = false
        }
      });
  } else if(type == 'skill') {
    requestObject['typeahead'] = 'typeahead_skills'
      this.showSkillLoader = true
      this.companyInsightsService.getTotalCompanyaggs(requestObject).subscribe((response: any) => {
        if (response.status == 'success' && response.data) {
          this.skillsList = response.data.aggs;
          this.showSkillLoader = false
        }
      });
  } else if(type == 'function') {
    requestObject['typeahead'] = 'typeahead_function'
    this.showfunctionLoader = true
    this.companyInsightsService.getTotalCompanyaggs(requestObject).subscribe((response: any) => {
      if (response.status == 'success' && response.data) {
        this.functionsList = response.data.aggs;
        this.showfunctionLoader = false
      }
    });
  }
}
}
